module.exports = "<div [class]=\"class\" [formGroup]=\"form\" >\n  <label [for]=\"id\" [translate]=\"key\"></label>\n  <input #range\n    type=\"range\"\n    [id]=\"id\"\n    [formControlName]=\"controlName\"\n    [min]=\"minValue\"\n    [max]=\"maxValue\"\n    [step]=\"step\"\n  >\n  <span class=\"range-slider-value\" [ngStyle]=\"sliderStyle\">{{ displayValue }}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/input-range-field/input-range-field.component.html
// module id = ../../../../../src/app/shared/components/forms/input-range-field/input-range-field.component.html
// module chunks = main